import * as React from "react";
import EditableList from "../../shared/components/EditableList";
import NotificationChannelHttpAuthenticationType from "../models/NotificationChannelHttpAuthenticationType";
import { Grid, IconButton, InputAdornment, TextField, Typography } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

class NotificationChannelHttpAuthenticationSettings extends React.Component<any, any> {
    public render() {
        return <>
            {this.props.notificationChannel.authenticationType !== NotificationChannelHttpAuthenticationType.NONE.id &&
                <>
                    <Grid container={true} spacing={24}>
                        <Grid item={true}>
                            <TextField
                                name="notificationChannel.authenticationConfig.tokenEndpoint"
                                label="Token Endpoint"
                                value={this.props.notificationChannel.authenticationConfig.tokenEndpoint || ''}
                                margin="normal"
                                className={this.props.classes.textField}
                                required={true}
                                onChange={this.props.getOnChange('notificationChannel.authenticationConfig.tokenEndpoint')}
                                error={!!this.props.errors['notificationChannel.authenticationConfig.tokenEndpoint']}
                                helperText={this.props.errors['notificationChannel.authenticationConfig.tokenEndpoint']}
                            />
                        </Grid>
                    </Grid>
                    <Grid container={true} spacing={24}>
                        <Grid item={true}>
                            <TextField
                                name="notificationChannel.authenticationConfig.clientId"
                                label="Client Id"
                                value={this.props.notificationChannel.authenticationConfig.clientId || ''}
                                margin="normal"
                                className={this.props.classes.textField}
                                required={true}
                                onChange={this.props.getOnChange('notificationChannel.authenticationConfig.clientId')}
                                error={!!this.props.errors['notificationChannel.authenticationConfig.clientId']}
                                helperText={this.props.errors['notificationChannel.authenticationConfig.clientId']}
                            />
                        </Grid>
                    </Grid>
                    <Grid container={true} spacing={24}>
                        <Grid item={true}>
                            <TextField
                                name="notificationChannel.authenticationConfig.clientSecret"
                                label="Client Secret"
                                type={this.props.showSecrets ? "text" : "password"}
                                value={this.props.notificationChannel.authenticationConfig.clientSecret || ''}
                                margin="normal"
                                className={this.props.classes.textField}
                                required={true}
                                onChange={this.props.getOnChange('notificationChannel.authenticationConfig.clientSecret')}
                                error={!!this.props.errors['notificationChannel.authenticationConfig.clientSecret']}
                                helperText={this.props.errors['notificationChannel.authenticationConfig.clientSecret']}
                                InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                          <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={this.props.onChangeShowSecrets}
                                          >
                                              {this.props.showSecrets ? <Visibility /> : <VisibilityOff />}
                                          </IconButton>
                                      </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container={true} spacing={24}>
                        <Grid item={true}>
                            <TextField
                                name="notificationChannel.authenticationConfig.clientScope"
                                label="Client Scopes"
                                placeholder={"Scopes separated by space"}
                                value={this.props.notificationChannel.authenticationConfig.clientScope || ''}
                                margin="normal"
                                className={this.props.classes.textField}
                                required={false}
                                onChange={this.props.getOnChange('notificationChannel.authenticationConfig.clientScope')}
                                error={!!this.props.errors['notificationChannel.authenticationConfig.clientScope']}
                                helperText={this.props.errors['notificationChannel.authenticationConfig.clientScope']}
                            />
                        </Grid>
                    </Grid>
                    <Grid container={true} spacing={24}>
                        <Grid item={true}>
                            <TextField
                                name="notificationChannel.authenticationConfig.grantType"
                                label="Grant Type"
                                value={this.props.notificationChannel.authenticationConfig.grantType || ''}
                                margin="normal"
                                className={this.props.classes.textField}
                                error={!!this.props.errors['notificationChannel.authenticationConfig.grantType']}
                                helperText={this.props.errors['notificationChannel.authenticationConfig.grantType']}
                                disabled = {true}
                            />
                        </Grid>
                    </Grid>

                    {this.props.notificationChannel.authenticationType === NotificationChannelHttpAuthenticationType.OAUTH2PASSWORDFLOW.id &&
                      <>
                          <Grid container={true} spacing={24}>
                              <Grid item={true}>
                                  <TextField
                                    name="notificationChannel.authenticationConfig.username"
                                    label="Username"
                                    value={this.props.notificationChannel.authenticationConfig.username || ''}
                                    margin="normal"
                                    className={this.props.classes.textField}
                                    required={true}
                                    onChange={this.props.getOnChange('notificationChannel.authenticationConfig.username')}
                                    error={!!this.props.errors['notificationChannel.authenticationConfig.username']}
                                    helperText={this.props.errors['notificationChannel.authenticationConfig.username']}
                                  />
                              </Grid>
                          </Grid>
                          <Grid container={true} spacing={24}>
                              <Grid item={true}>
                                  <TextField
                                    name="notificationChannel.authenticationConfig.password"
                                    label="Password"
                                    type={this.props.showSecrets ? "text" : "password"} 
                                    value={this.props.notificationChannel.authenticationConfig.password || ''}
                                    margin="normal"
                                    className={this.props.classes.textField}
                                    required={true}
                                    onChange={this.props.getOnChange('notificationChannel.authenticationConfig.password')}
                                    error={!!this.props.errors['notificationChannel.authenticationConfig.password']}
                                    helperText={this.props.errors['notificationChannel.authenticationConfig.password']}
                                    InputProps={{ 
                                        endAdornment: (
                                          <InputAdornment position="end">
                                              <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={this.props.onChangeShowSecrets}
                                              >
                                                  {this.props.showSecrets ? <Visibility /> : <VisibilityOff />}
                                              </IconButton>
                                          </InputAdornment>
                                        )
                                    }}
                                  />
                              </Grid>
                          </Grid>
                      </>
                    }
                    
                    <Grid container={true} className={this.props.classes.editableList}>
                        <Grid item={true} xs={4}>
                        <Typography color="textSecondary" gutterBottom={true}>
                            Authentication Headers
                        </Typography>
                            <EditableList
                              editable
                              directlyEditable
                              headers={
                                  [
                                      "Key",
                                      "Value"
                                  ]
                              }
                              items={this.props.notificationChannel.authenticationConfig.customHeadersList}
                              newItem={{
                                  key: '',
                                  value: ''
                              }}
                              settings={{
                                  key: {
                                      type: 'text'
                                  },
                                  value: {
                                      type: 'text'
                                  }
                              }}
                              onChange={this.props.onChangeHeaders}
                            />
                        </Grid>
                    </Grid>
                </>}
        </>
    }
}

export default NotificationChannelHttpAuthenticationSettings;


// WEBPACK FOOTER //
// ./src/modules/organization/components/NotificationChannelHttpAuthenticationSettings.tsx